import { useEffect, useState } from 'react';
// eslint-disable-next-line jira/import-whitelist
import { useSpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/page-ready-state/index.tsx';
import getRapidBoardAppResources from './get-data/index.tsx';

const GetCBBResources = () => {
	const [{ isReady }] = useSpaStatePageReady();
	const [delayed, setDelayed] = useState(true);

	// Get ready for the worst code:
	// Adding a timeout to wait for other batch files to get loaded to reduce the batch size.
	useEffect(() => {
		let timer: ReturnType<typeof setTimeout> | null = null;
		if (isReady) {
			timer = setTimeout(() => setDelayed(false), 3000);
		}
		if (isReady && !delayed) {
			getRapidBoardAppResources();
		}
		return () => {
			if (timer) clearTimeout(timer);
		};
	}, [delayed, isReady]);

	return null;
};
export default GetCBBResources;
